import { Layout, Modal } from '@enterprise-ui/canvas-ui-react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const HeaderWrapper = styled.header`
  display: flex;
  align-items: center;
  width: 100%;
  grid-column: 1 / -1;
  box-sizing: border-box;
  background-color: #000;
  color: #fff;
  height: 64px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
`

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
`

export const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  height: 100%;
  background-color: #c4bfa8;
`

export const AppBarContent = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  height: 100%;

  @media (max-width: 1040px) {
    display: none;
  }
`

export const MenuButton = styled.button`
  display: none;
  background: transparent;
  border: none;
  color: #fff;
  cursor: pointer;
  padding: 8px;
  margin-left: 8px;
  align-items: center;
  justify-content: center;

  @media (max-width: 1040px) {
    display: flex;
    order: -1;
    margin-left: 0;
  }
`

export const ToolsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding-right: 24px;
  margin-left: auto;
`

export const HelpButton = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  color: #fff;
  text-decoration: none;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.12);
  }
`

export const StyledAccountSelector = styled(Modal)`
  z-index: 99 !important;

  .C-Modal__container {
    max-width: 40vw;
  }

  .C-Autocomplete__Options {
    max-height: 125px;
  }

  h1.C-Heading {
    padding-left: var(--canvas-spacing--lg) !important;
    padding-top: var(--canvas-spacing--lg) !important;
  }

  .C-Modal__container__content {
    padding-bottom: var(--canvas-spacing--sm) !important;
  }
`

export const StyledFeedbackForm = styled(Modal)`
  .C-FormField__Label {
    font-size: 16px;
  }

  .C-Input--type-info.isErrored {
    display: none;
  }

  .C-Autocomplete__Options {
    max-height: 125px;
  }

  h1.C-Heading {
    padding-left: var(--canvas-spacing--lg) !important;
    padding-top: var(--canvas-spacing--lg) !important;
  }

  .C-Modal__container__content {
    padding-bottom: var(--canvas-spacing--sm) !important;
  }
`
export const StyledHeaderLayout = styled(Layout.Header)`
  .userprofile_btn {
    color: #fff !important;
    background: transparent !important;
    .profileIcon {
      color: #fff;
      padding-right: 0.5em;
      &:hover {
        color: var(--canvas-background-color--interactive-hover);
      }
    }
  }
  .C-Dropdown .C-DropdownMenu {
    top: 45px;
    overflow-y: auto !important;
  }
  .new-report-btn {
    min-width: 120px;
  }
  .header-container {
    flex-wrap: nowrap;
  }
  .menu-container {
    width: calc(100vw - 490px);
    a {
      margin: 0 18px 10px 18px;
      white-space: nowrap;
      display: inline-block;
    }
  }
`
